import { render, staticRenderFns } from "./privacy-policy.vue?vue&type=template&id=016a0c68&scoped=true&"
import script from "./privacy-policy.vue?vue&type=script&lang=ts&"
export * from "./privacy-policy.vue?vue&type=script&lang=ts&"
import style0 from "./privacy-policy.vue?vue&type=style&index=0&id=016a0c68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016a0c68",
  null
  
)

component.options.__file = "privacy-policy.vue"
export default component.exports